import { ArrowLeftIcon, ArrowRightIcon } from "@chakra-ui/icons";
import {
  Avatar,
  Box,
  Button,
  Center,
  Checkbox,
  Flex,
  HStack,
  Input,
  InputGroup,
  InputRightElement,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Tab,
  Table,
  TableContainer,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useToast,
} from "@chakra-ui/react";
import { ChangeEvent, useEffect, useState } from "react";
import { BsChevronDown } from "react-icons/bs";
import { RiEyeLine, RiSearch2Line } from "react-icons/ri";
import Pagination from "react-paginate";
import { useNavigate } from "react-router-dom";
import AdminDashboardHeader from "../../components/admin/AdminHeader";
import AdminSidebar from "../../components/admin/AdminSidebar";
import Loading from "../../components/common/Loading";
import { IUserProfile } from "../../models/admin/user.model";
import { ICourseApplication } from "../../models/course-application.model";
import AdminHelpers from "../../services/admin/admin.service";
import courseEnrolmentService from "../../services/course-enrolment.service";
import Adminroutes from "./routes";

const AdminReview = () => {
  const navigate = useNavigate();
  const [trainees, setTrainees] = useState<IUserProfile[]>([]);
  const [trainers, setTrainers] = useState<IUserProfile[]>([]);
  const [courses, setCourses] = useState<ICourseApplication[]>([]);
  const [filteredcourses, setFilteredCourses] = useState<ICourseApplication[]>(
    []
  );
  const [filteredTrainers, setFilteredTrainers] = useState<IUserProfile[]>([]);
  const [filteredTrainees, setFilteredTrainees] = useState<IUserProfile[]>([]);
  const [checkedIds, setCheckedIds] = useState<Array<number>>([]);
  const [isSearchEmpty, setIsSearchEmpty] = useState(false);
  const toast = useToast();
  const [loading, setLoading] = useState(true);
  const [allChecked, setAllChecked] = useState(false);

  // User is currently on this page
  const [currentPage, setCurrentPage] = useState(0);
  // No of Records to be displayed on each page
  const [recordsPerPage, setRecordsPerPage] = useState(20);
  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  // Records to be displayed on the current page
  const currentRecords: any = filteredcourses.slice(
    currentPage * recordsPerPage,
    (currentPage + 1) * recordsPerPage
  );
  const nPages = Math.ceil(filteredcourses.length / recordsPerPage);

  useEffect(() => {
    AdminHelpers.getTrainees()
      .then((response) => {
        setTrainees(
          response.data.filter((each) => each.approval_status == "New")
        );
        setFilteredTrainees(
          response.data.filter((each) => each.approval_status == "New")
        );
      })
      .catch((err) => err);
    AdminHelpers.getTrainers()
      .then((response) => {
        setTrainers(
          response.data.filter((each) => each.approval_status == "New")
        );
        setFilteredTrainers(
          response.data.filter((each) => each.approval_status == "New")
        );
      })
      .catch((err) => err);
    courseEnrolmentService
      .getCourseApplications()
      .then((response) => {
        setCourses(response.data);
        setFilteredCourses(response.data);
        setLoading(false);
      })
      .catch((err) => err);
  }, []);

  const viewTraineeApplication = async (trainee_id: string) => {
    navigate(Adminroutes.ReviewTraineeLink(trainee_id));
  };
  const viewTrainerApplication = async (trainer_id: string) => {
    navigate(Adminroutes.ReviewTrainerLink(trainer_id));
  };
  const viewCourseApplication = async (course_id: string) => {
    navigate(Adminroutes.ReviewApplicationLink(course_id));
  };

  const handleSearchChange = (event: ChangeEvent<HTMLInputElement>) => {
    const searchTerm = event.target.value.toLowerCase();
    if (!searchTerm) {
      setFilteredTrainees(trainees);
    } else {
      if (trainees) {
        const filtered = trainees.filter((each: any) =>
          each.name.toLowerCase().includes(searchTerm)
        );
        setFilteredTrainees(filtered);
        if (filtered && filtered.length > 0) setIsSearchEmpty(false);
        else setIsSearchEmpty(true);
      }
    }
  };
  const handleSearchChangeTr = (event: ChangeEvent<HTMLInputElement>) => {
    const searchTerm = event.target.value.toLowerCase();
    if (!searchTerm) {
      setFilteredTrainers(trainers);
    } else {
      if (trainers) {
        const filtered = trainers.filter((each: any) =>
          each.name.toLowerCase().includes(searchTerm)
        );
        setFilteredTrainers(filtered);
        if (filtered && filtered.length > 0) setIsSearchEmpty(false);
        else setIsSearchEmpty(true);
      }
    }
  };
  const handleSearchChangeCr = (event: ChangeEvent<HTMLInputElement>) => {
    const searchTerm = event.target.value.toLowerCase();
    if (!searchTerm) {
      setFilteredCourses(courses);
    } else {
      if (courses) {
        const filtered = courses.filter((each: any) =>
          each.course.name.toLowerCase().includes(searchTerm)
        );
        setFilteredCourses(filtered);
        if (filtered && filtered.length > 0) setIsSearchEmpty(false);
        else setIsSearchEmpty(true);
      }
    }
  };

  const handleShortlistApplications = async (checkedIds: Array<number>) => {
    if (checkedIds.length !== 0 || checkedIds !== null) {
      const data = {
        application_ids: checkedIds,
      };

      try {
        const Res = await AdminHelpers.shortlistApplication(data);
        if (Res) {
          toast({
            title: "Shortlist Application",
            description: `Applicants shortlisted successfully`,
            status: "success",
          });
          navigate(Adminroutes.Review);
        }
      } catch (error: any) {
        toast({
          title: "Shortlist Application",
          description: `Something went wrong`,
          status: "error",
        });
      }
    } else {
      toast({
        title: "Shortlist Application",
        description: `Select applicants you want to shortlist`,
        status: "error",
      });
      return;
    }
  };

  const handlePageChange = (page: any) => {
    setCurrentPage(page.selected);
  };

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <>
          <Flex
            minHeight={"100vh"}
            height={"auto"}
            boxSizing="border-box"
            maxWidth={"100hw"}
          >
            <Box
              width={["3.5rem", "3.5rem", "3.5rem", "20%"]}
              position="relative"
              top="0"
              left="0"
              zIndex="100"
            >
              <AdminSidebar />
            </Box>

            <Box width="100%">
              <AdminDashboardHeader />
              <Box
                pt="30px"
                px={["20px", "30px"]}
                width={"100%"}
                bg="#F9F8F8"
                height={"auto"}
                minHeight={"95vh"}
                maxHeight={"95vh"}
                overflowX={"scroll"}
                className="scroll-hidden"
              >
                <Flex
                  justifyContent="space-between"
                  alignItems="center"
                  py="26px"
                >
                  <Box color="#2B2B2B" fontWeight="800" fontSize="27px">
                    Pending Review
                  </Box>

                  <HStack>
                    <Menu>
                      <MenuButton
                        as={Button}
                        rightIcon={<BsChevronDown />}
                        bg="white"
                        color="#616161"
                        variant={"outline"}
                        size="sm"
                        fontSize={13}
                        width="106px"
                        border="1px solid"
                        borderColor="#9E9E9E"
                      >
                        2022/2023
                      </MenuButton>
                      <MenuList fontSize={12}>
                        <MenuItem>2022/2023</MenuItem>

                        <MenuItem>2021/2022</MenuItem>
                        <MenuItem> 2020/2021</MenuItem>
                        <MenuItem>2019/2020</MenuItem>
                      </MenuList>
                    </Menu>
                  </HStack>
                </Flex>
                <Tabs colorScheme="red">
                  <TabList
                    py="10px"
                    px={["10px", "10px", "20px", "30px"]}
                    bg="white"
                    justifyContent="space-between"
                    width={"100%"}
                    overflowX={"scroll"}
                    className="scroll-hidden"
                  >
                    <Tab>
                      <HStack>
                        <Text
                          fontSize={["14px", "14px", "16px", "18px"]}
                          whiteSpace="nowrap"
                          ml={3}
                          color="#616161"
                          fontWeight="600"
                        >
                          Trainees
                        </Text>
                        <Center
                          bg="#EC3337"
                          width={["20px", "20px", "30px", "32px"]}
                          height={["20px", "20px", "30px", "32px"]}
                          borderRadius="50%"
                        >
                          <Text color="white">{trainees.length}</Text>
                        </Center>
                      </HStack>
                    </Tab>
                    <Tab>
                      <HStack>
                        <Text
                          fontSize={["14px", "14px", "16px", "18px"]}
                          whiteSpace="nowrap"
                          ml={3}
                          color="#616161"
                          fontWeight="600"
                        >
                          Trainers
                        </Text>
                        <Center
                          bg="#EC3337"
                          width={["20px", "20px", "30px", "32px"]}
                          height={["20px", "20px", "30px", "32px"]}
                          borderRadius="50%"
                        >
                          <Text color="white">{trainers.length}</Text>
                        </Center>
                      </HStack>
                    </Tab>
                    <Tab>
                      <HStack>
                        <Text
                          fontSize={["14px", "14px", "16px", "18px"]}
                          whiteSpace="nowrap"
                          ml={3}
                          color="#616161"
                          fontWeight="600"
                        >
                          Course Application
                        </Text>
                        <Center
                          bg="#EC3337"
                          width={["20px", "20px", "30px", "32px"]}
                          height={["20px", "20px", "30px", "32px"]}
                          borderRadius="50%"
                        >
                          <Text color="white">{courses.length}</Text>
                        </Center>
                      </HStack>
                    </Tab>
                  </TabList>
                  <TabPanels>
                    <TabPanel>
                      <Flex py="15px" justifyContent="">
                        <InputGroup
                          color="brand.subtitle"
                          bg="white"
                          width={["90%", "90%", "50%", "30%"]}
                        >
                          <Input
                            height="40px"
                            placeholder="Search trainees"
                            onChange={(e) => handleSearchChange(e)}
                            fontSize={12}
                            size="sm"
                          />

                          <InputRightElement
                            pointerEvents="none"
                            children={
                              <RiSearch2Line color="red" size="0.9rem" />
                            }
                          />
                        </InputGroup>
                      </Flex>
                      <Box width="100%">
                        <TableContainer>
                          <Table variant="simple">
                            <Thead mb="10px" fontSize="14px">
                              <Tr
                                pb="10px"
                                borderBottom="1px solid"
                                borderColor="#D5D5D5"
                              >
                                <Th width="70px">
                                  <Checkbox></Checkbox>
                                </Th>
                                <Th textTransform="none">Trainee</Th>
                                <Th textTransform="none">Course/Discipline</Th>
                                <Th textTransform="none">
                                  Institution Attended
                                </Th>
                                <Th textTransform="none">Class of degree</Th>
                                <Th textTransform="none">Options</Th>
                              </Tr>
                            </Thead>
                            <Tbody>
                              {filteredTrainees &&
                                filteredTrainees.map((eachtrainee, index) => (
                                  <Tr key={index} bg="white">
                                    <Td width="70px">
                                      <Checkbox></Checkbox>
                                    </Td>
                                    <Td>
                                      <HStack spacing="10px">
                                        <Avatar
                                          name={eachtrainee.name}
                                          size="sm"
                                        />

                                        <Text
                                          fontWeight="600"
                                          textTransform="capitalize"
                                          fontSize="16px"
                                          color="#616161"
                                        >
                                          {eachtrainee.name}
                                        </Text>
                                      </HStack>
                                    </Td>
                                    <Td>
                                      {" "}
                                      <Text>
                                        {eachtrainee.educations.length > 0
                                          ? eachtrainee.educations[0].discipline
                                            ? eachtrainee.educations[0]
                                                .discipline
                                            : "nil"
                                          : "nil"}
                                      </Text>
                                    </Td>
                                    <Td>
                                      {" "}
                                      <Text>
                                        {eachtrainee.educations.length > 0
                                          ? eachtrainee.educations[0]
                                              .institution
                                            ? eachtrainee.educations[0]
                                                .institution
                                            : "nil"
                                          : "nil"}
                                      </Text>
                                    </Td>
                                    <Td>
                                      <Text>
                                        {eachtrainee.educations.length > 0
                                          ? eachtrainee.educations[0]
                                              .class_of_degree
                                            ? eachtrainee.educations[0]
                                                .class_of_degree
                                            : "nil"
                                          : "nil"}
                                      </Text>
                                    </Td>

                                    <Td>
                                      <HStack
                                        cursor="pointer"
                                        onClick={() =>
                                          viewTraineeApplication(
                                            eachtrainee.uuid
                                          )
                                        }
                                        width="116px"
                                        border="1px solid"
                                        borderColor="lightgray"
                                        borderRadius="10px"
                                        py="6px"
                                        px="16px"
                                        color="#EC3337"
                                        spacing="10px"
                                      >
                                        <RiEyeLine
                                          fontWeight="700"
                                          fontSize="18px"
                                        />
                                        <Text fontWeight="600" fontSize="16px">
                                          Review
                                        </Text>
                                      </HStack>
                                    </Td>
                                  </Tr>
                                ))}
                            </Tbody>
                          </Table>
                        </TableContainer>
                      </Box>
                    </TabPanel>
                    <TabPanel>
                      <Flex py="15px" justifyContent="">
                        <InputGroup
                          color="brand.subtitle"
                          bg="white"
                          width={["90%", "90%", "50%", "30%"]}
                        >
                          <Input
                            height="40px"
                            placeholder="Search trainers"
                            onChange={(e) => handleSearchChangeTr(e)}
                            fontSize={12}
                            size="sm"
                          />

                          <InputRightElement
                            pointerEvents="none"
                            children={
                              <RiSearch2Line color="red" size="0.9rem" />
                            }
                          />
                        </InputGroup>
                      </Flex>
                      <Box width="100%">
                        <TableContainer>
                          <Table variant="simple">
                            <Thead mb="10px">
                              <Tr
                                pb="10px"
                                fontSize="14px"
                                borderBottom="1px solid"
                                borderColor="#D5D5D5"
                              >
                                <Th width="70px">
                                  <Checkbox></Checkbox>
                                </Th>
                                <Th textTransform="none">Trainer</Th>
                                <Th textTransform="none">Course/Discipline</Th>
                                <Th textTransform="none">
                                  Institution Attended
                                </Th>
                                <Th textTransform="none">Class of degree</Th>
                                <Th textTransform="none">Options</Th>
                              </Tr>
                            </Thead>
                            <Tbody>
                              {filteredTrainers &&
                                filteredTrainers.map((eachtrainer, index) => (
                                  <Tr key={index} bg="white">
                                    <Td width="70px">
                                      <Checkbox></Checkbox>
                                    </Td>
                                    <Td>
                                      <HStack spacing="10px">
                                        <Avatar
                                          // name={
                                          //   eachtrainer.bio &&
                                          //   `${eachtrainer.bio.firstname} ${eachtrainer.bio.lastname}`
                                          // }
                                          name={
                                            eachtrainer && `${eachtrainer.name}`
                                          }
                                          size="sm"
                                        />

                                        <Text
                                          fontWeight="600"
                                          textTransform="capitalize"
                                          fontSize="16px"
                                          color="#616161"
                                        >
                                          {/* {eachtrainer.bio &&
                                            `${eachtrainer.bio.firstname} ${eachtrainer.bio.lastname}`} */}
                                          {eachtrainer && `${eachtrainer.name}`}
                                        </Text>
                                      </HStack>
                                    </Td>
                                    <Td>
                                      {" "}
                                      <Text>
                                        {eachtrainer.educations.length > 0
                                          ? eachtrainer.educations[0].discipline
                                            ? eachtrainer.educations[0]
                                                .discipline
                                            : "nil"
                                          : "nil"}
                                      </Text>
                                    </Td>
                                    <Td>
                                      {" "}
                                      <Text>
                                        {eachtrainer.educations.length > 0
                                          ? eachtrainer.educations[0]
                                              .institution
                                            ? eachtrainer.educations[0]
                                                .institution
                                            : "nil"
                                          : "nil"}
                                      </Text>
                                    </Td>
                                    <Td>
                                      <Text>
                                        {eachtrainer.educations.length > 0
                                          ? eachtrainer.educations[0]
                                              .class_of_degree
                                            ? eachtrainer.educations[0]
                                                .class_of_degree
                                            : "nil"
                                          : "nil"}
                                      </Text>
                                    </Td>

                                    <Td>
                                      <HStack
                                        cursor="pointer"
                                        onClick={() =>
                                          viewTrainerApplication(
                                            eachtrainer.uuid
                                          )
                                        }
                                        width="116px"
                                        border="1px solid"
                                        borderColor="lightgray"
                                        borderRadius="10px"
                                        py="6px"
                                        px="16px"
                                        color="#EC3337"
                                        spacing="10px"
                                      >
                                        <RiEyeLine
                                          fontWeight="700"
                                          fontSize="18px"
                                        />
                                        <Text fontWeight="600" fontSize="16px">
                                          Review
                                        </Text>
                                      </HStack>
                                    </Td>
                                  </Tr>
                                ))}
                            </Tbody>
                          </Table>
                        </TableContainer>
                      </Box>
                    </TabPanel>
                    <TabPanel>
                      <Flex py="15px" justifyContent="space-between">
                        <InputGroup
                          color="brand.subtitle"
                          bg="white"
                          width={["90%", "90%", "50%", "30%"]}
                        >
                          <Input
                            height="40px"
                            placeholder="Search for course"
                            onChange={(e) => handleSearchChangeCr(e)}
                            fontSize={12}
                            size="sm"
                          />
                          <InputRightElement
                            pointerEvents="none"
                            children={
                              <RiSearch2Line color="red" size="0.9rem" />
                            }
                          />
                        </InputGroup>
                        <Button
                          colorScheme="red"
                          variant={"outline"}
                          fontSize="14px"
                          disabled={checkedIds.length <= 0}
                          onClick={() =>
                            handleShortlistApplications(checkedIds)
                          }
                        >
                          SHORTLIST
                        </Button>
                      </Flex>
                      <Box width="100%">
                        <TableContainer>
                          <Table variant="simple">
                            <Thead mb="10px">
                              <Tr
                                pb="10px"
                                fontSize="14px"
                                borderBottom="1px solid"
                                borderColor="#D5D5D5"
                                fontWeight="700"
                              >
                                <Th>
                                  <Checkbox
                                    isChecked={
                                      checkedIds.length ===
                                      currentRecords.length
                                    }
                                    onChange={(e) => {
                                      if (e.target.checked) {
                                        const allCourseIds = currentRecords.map(
                                          (eachcourse: any) => eachcourse.id
                                        );
                                        setCheckedIds(allCourseIds);
                                      } else {
                                        setCheckedIds([]);
                                      }
                                    }}
                                    colorScheme="red"
                                  />
                                </Th>
                                <Th textTransform="none">Applicant</Th>
                                <Th textTransform="none">Course Applied</Th>
                                <Th textTransform="none">Amount Paid</Th>
                                <Th textTransform="none">Payment Type</Th>
                                <Th textTransform="none">Options</Th>
                              </Tr>
                            </Thead>
                            <Tbody>
                              {currentRecords.length === 0 ||
                              currentRecords == null ? (
                                <Box
                                  display="flex"
                                  justifyContent="center"
                                  alignContent="center"
                                  width="100%"
                                >
                                  <Text fontWeight="800" fontSize="16px">
                                    No new course applicants
                                  </Text>
                                </Box>
                              ) : (
                                currentRecords?.map(
                                  (eachcourse: any, index: number) => (
                                    <Tr key={index} bg="white">
                                      <Td>
                                        <Checkbox
                                          colorScheme="red"
                                          isChecked={checkedIds.includes(
                                            eachcourse.id
                                          )}
                                          onChange={(e) => {
                                            if (e.target.checked) {
                                              setCheckedIds([
                                                ...checkedIds,
                                                eachcourse.id,
                                              ]);
                                            } else {
                                              setCheckedIds(
                                                checkedIds.filter(
                                                  (checkedId) =>
                                                    checkedId !== eachcourse.id
                                                )
                                              );
                                            }
                                          }}
                                        />
                                      </Td>
                                      <Td>
                                        <HStack spacing="10px">
                                          <Avatar
                                            name={eachcourse.user.name}
                                            size="sm"
                                          />

                                          <Text
                                            fontWeight="600"
                                            fontSize="16px"
                                            color="#616161"
                                          >
                                            {eachcourse.user.name}
                                          </Text>
                                        </HStack>
                                      </Td>
                                      <Td>
                                        {" "}
                                        <Text textTransform="capitalize">
                                          {eachcourse.course.name.substring(
                                            0,
                                            20
                                          )}
                                        </Text>
                                      </Td>
                                      <Td>
                                        {" "}
                                        <Text textTransform="capitalize">
                                          {eachcourse.course.cost}
                                        </Text>
                                      </Td>
                                      <Td>
                                        <Text textTransform="capitalize">
                                          {eachcourse.payment_mode}
                                        </Text>
                                      </Td>

                                      <Td textTransform="capitalize">
                                        <HStack
                                          cursor="pointer"
                                          onClick={() =>
                                            viewCourseApplication(
                                              eachcourse.uuid
                                            )
                                          }
                                          width="116px"
                                          border="1px solid"
                                          borderColor="lightgray"
                                          borderRadius="10px"
                                          py="6px"
                                          px="16px"
                                          color="#EC3337"
                                          spacing="10px"
                                        >
                                          <RiEyeLine
                                            fontWeight="700"
                                            fontSize="18px"
                                          />
                                          <Text
                                            fontWeight="600"
                                            fontSize="16px"
                                          >
                                            Review
                                          </Text>
                                        </HStack>
                                      </Td>
                                    </Tr>
                                  )
                                )
                              )}
                            </Tbody>
                          </Table>
                          {currentRecords.length > 0 ? (
                            <Flex
                              pb="1rem"
                              flexDirection={"row"}
                              alignItems={"center"}
                              width="100%"
                              justifyContent={"center"}
                            >
                              <Pagination
                                breakLabel="..."
                                nextLabel={
                                  <ArrowRightIcon style={{ fontSize: 14 }} />
                                }
                                onPageChange={handlePageChange}
                                pageRangeDisplayed={30}
                                pageCount={nPages}
                                previousLabel={
                                  <ArrowLeftIcon style={{ fontSize: 14 }} />
                                }
                                containerClassName="pagination2"
                                pageLinkClassName="page-num2"
                                previousLinkClassName="page-num2"
                                nextLinkClassName="page-num2"
                                activeLinkClassName="active2"
                              />
                            </Flex>
                          ) : (
                            ""
                          )}
                        </TableContainer>
                      </Box>
                    </TabPanel>
                  </TabPanels>
                </Tabs>
              </Box>
            </Box>
          </Flex>
        </>
      )}
    </>
  );
};

export default AdminReview;
